import _ from 'lodash'

const isBlank = (element) => (
  (_.isObject(element) && _.isEmpty(element))
  || _.isNil(element)
  || element === ''
  || element === 'undefined'
  || element === 'null'
)

const presence = (element, defaultTo) => isPresent(element) ? element : defaultTo
const isPresent = (element) => !isBlank(element)
const titleize = (string) => _(_.snakeCase(string).replace('_', ' ')).words().map((item) => _.upperFirst(item)).join(' ')

_.mixin({
  isBlank: isBlank,
  isPresent: isPresent,
  presence: presence,
  titleize: titleize
})

export default _
